import * as React from "react";

import {
  useApplyAGiftcardForm,
  useMyBagPresentationModel,
} from "../providers";

export const AppliedAGiftCards = () => {
  const {
    removeAGiftcard,
  } = useApplyAGiftcardForm();

  const { presentationMyBagOrder } = useMyBagPresentationModel();


  const myAppliedGiftCards = React.useMemo(() => {
    return presentationMyBagOrder?.giftCardValueBreakdown;
  }, [presentationMyBagOrder]);


  const handleRemoveGiftcard = React.useCallback(
    (giftCardId: string) => {
      const cardToRemove = myAppliedGiftCards?.find(
        (gc) => gc.privateBackendCode === giftCardId
      );

      if (cardToRemove) {
        removeAGiftcard(cardToRemove);
      }
    },
    [removeAGiftcard, myAppliedGiftCards]
  );

  return (
    <React.Fragment>
      {myAppliedGiftCards && myAppliedGiftCards.length > 0 && (
        <div className="apply-a-giftcard applied-giftcard">
          <p>{`We have applied the following to your order:`}</p>

          {myAppliedGiftCards.map((giftCard, index) => (
            <div key={giftCard.privateBackendCode || index} className="the-giftcard-that-was-applied">
              <div className="mhs">
                <p className="presentableCode">
                  <span>{`Gift Card `}</span>
                  <span className="gift-card-number">{`${giftCard.presentableCode}`}</span>
                </p>
                <p className="after-checkout">
                  <span>{`Remaining `}</span>
                  <span className="after-checkout-value">
                  {`\$${giftCard.postApplicationValueLeftOnTheGiftcard.toFixed(2)}`}
                </span>
                </p>

                <p className="value">
                  <span>{`Applied `}</span>
                  <span className="value-applied">{`\$${giftCard.appliedValue.toFixed(2)}`}</span>
                </p>

                <button
                  onClick={() =>
                    handleRemoveGiftcard(giftCard.privateBackendCode)
                  }
                >
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </React.Fragment>
  );
};
